
{
  "fr": {
    "createCustomerProjectButton": {
      "authModalTitle": "Connectez-vous pour enregistrer votre projet",
      "button": {
        "label": "Enregistrer mon projet",
        "error": "Une erreur s'est produite pendant la création de votre projet. Veuillez réessayer ou nous contacter.",
        "success": "Le gobelet a bien été sauvegardé en tant que projet."
      }
    }
  }
}
